<template>
  <v-container>
    <v-row style="padding-left: 20px;">
      <span
        style="color: #0A7EA5; font-size: 16px; cursor: pointer;"
        @click="getBackList()"
        class="hover-back"
      >
        &lt;Back
      </span>
    </v-row>
    <v-card class="pt-6 pl-6 pr-6 pb-2 mt-10" elevation="0">
      <v-row style="margin-top: 10px; margin-bottom: 20px">
        <v-col
          cols="11"
          lg="11"
          md="711"
          style="margin-left:  auto; margin-right: auto;"
        >
          <v-row>
            <span style="color: #222222; font-size: 25px; font-weight: 500;"
              >Approve Time Off History</span
            >
          </v-row>
        </v-col>
      </v-row>
      <v-row
        style="margin-top: 20px; min-height: 20rem;"
        v-if="datashowAll.length > 0"
      >
        <v-col
          cols="11"
          lg="11"
          md="11"
          style="margin-left:  auto; margin-right: auto;"
        >
          <v-row
            v-for="item in paginatedItems"
            :key="item.id"
            class="hover-bg"
            @click="goToLeaveApproveById(item.id, item.userId)"
          >
            <v-col cols="1" md="1" class="d-flex flex-column justify-center">
              <!-- <v-icon 
                        style="
                            font-size: 40px;
                            color: #0A7EA5;
                        "
                    >
                    mdi-clipboard-text-clock-outline
                    </v-icon> -->
              <v-avatar size="40">
                <v-img
                  v-if="item.image != ''"
                  :lazy-src="item.image_profile"
                  max-height="45px"
                  max-width="45px"
                  :src="item.image_profile"
                ></v-img>
                <v-icon dark style="color: #808080 ; font-size: 50px;" v-else>
                  mdi-account-circle
                </v-icon>
              </v-avatar>
            </v-col>
            <v-col cols="11" md="11" class="d-flex flex-column justify-center">
              <v-row>
                <v-col cols="6" md="6">{{ item.leave_type }}</v-col>
                <v-col cols="6" md="6" class="d-flex justify-end">
                  <span
                    style="
                            color: #06A458; 
                            font-size: 11px; 
                            text-align: right; 
                        "
                    v-if="item.status_name == 'Approved'"
                  >
                    {{ item.status_name }}
                  </span>
                  <span
                    style="
                            color: red; 
                            font-size: 11px; 
                            text-align: right; 
                        "
                    v-else-if="item.status_name == 'Rejected'"
                  >
                    {{ item.status_name }}
                  </span>
                  <span
                    style="
                                color: #ffbe5c; 
                                font-size: 11px; 
                                text-align: right; 
                            "
                    v-else
                  >
                    Pending
                  </span>
                </v-col>
              </v-row>
              <v-row style="margin-top: -15px;">
                <v-col cols="12" md="12" class="d-flex">
                  <span
                    style="color: #222222; font-size: 11px; display: inline-block; text-align: left;"
                    v-if="item.name_eng != ' '"
                    >{{ item.name_eng }}</span
                  >
                  <span
                    style="color: #222222; font-size: 11px; display: inline-block; text-align: left;"
                    v-else
                    >{{ item.name_th }}</span
                  >
                  <v-spacer></v-spacer>
                  <span
                    style="color: #222222; font-size: 11px; display: inline-block; text-align: right;"
                    >{{ item.description }}</span
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row style="margin-top: 100px; min-height: 20rem;" v-else>
        <v-col
          cols="10"
          lg="7"
          md="7"
          style="margin-left:  auto; margin-right: auto;"
        >
          <v-row class="d-flex justify-center">
            <span
              style="color: #0A7EA5; font-size: 20px; display: inline-block; text-align: right;"
              >No Approve Time Off</span
            >
          </v-row>
        </v-col>
      </v-row>
      <v-row style="margin-top: 20px;" v-if="itemsPerPage < datashowAll.length">
        <v-col
          cols="12"
          lg="12"
          md="12"
          style="margin-left:  auto; margin-right: auto;"
        >
          <v-row>
            <v-col cols="12" md="12" class="d-flex justify-end">
              <div class="pagination-info">
                <v-btn
                  v-if="!(page === 1)"
                  icon
                  @click="previousPage"
                  style="color: #0A7EA5;"
                >
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>

                <span style="font-size: 12px;"
                  >Page {{ page }} of {{ pageCount }}</span
                >

                <v-btn
                  v-if="!(page === pageCount)"
                  icon
                  @click="nextPage"
                  style="color: #0A7EA5;"
                >
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
                <v-btn v-else icon style="color: #0A7EA5;"> </v-btn>
              </div>
              <v-pagination
                v-model="page"
                :length="pageCount"
                :total-visible="5"
                class="hidden-pagination"
                total-visible="19"
              ></v-pagination>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server, imageUrl } from "@/services/constants";
import { language } from "../language/Leavelist.js";
import unity from "@/unity/unity";

export default {
  name: "leave-list",
  data(vm) {
    return {
      authorize: [],
      search: "",
      menu: false,
      menu2: false,
      selectstatus: "",
      dataAll: [],
      status: ["Draft", "Submit"],
      datefrom: null,
      dateto: null,
      dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      seticonsearchmore: { icon: "mdi mdi-chevron-down", action: false },
      setlanguage: language.en,
      defaultlanguage: "en",
      // regexlang: "th",
      chooselanguage: [
        { name: "en", flag: "gb" },
        { name: "th", flag: "th" },
      ],

      page: 1, // หน้าเริ่มต้น
      itemsPerPage: 5, // จำนวนรายการต่อหน้า
      leavehistory_list: [],
      datashowAll: [],
    };
  },
  async beforeCreate() {
    console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
  async created() {
    // this.headers = language.en.headertable;
    // this.initialize();
  },
  beforeUpdate() {},
  computed: {
    computeddatefromFormatted() {
      return unity.formatDate(this.datefrom);
    },
    computeddateToFormatted() {
      return unity.formatDate(this.dateto);
    },
    itemsForSelected() {
      if (this.search.length) {
        return this.dataSource.filter((item) => this.search.includes(item));
      }
      return this.dataSource;
    },
    pageCount() {
      return Math.ceil(this.datashowAll.length / this.itemsPerPage); // คำนวณจำนวนหน้าทั้งหมด
    },
    paginatedItems() {
      const start = (this.page - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.datashowAll.slice(start, end); // ดึงรายการที่ต้องแสดงในแต่ละหน้า
    },
  },
  async mounted() {
    await api.checkVersion();
    this.userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

    // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center"
      );
      this.$router.back();
    }

    // const router_path = parser.pathname.replace("/", "");

    // const res_auth = await api.getAuthorize(this.userId, router_path);

    // // console.log("res_auth:" + JSON.stringify(res_auth.data));

    // this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    // this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    // this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    // this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;

    //    if (!this.authorize_view) {
    //   this.$router.push("/not-found");
    // }

    // // ----------------- Check Authorize ---------------------------

    // let comp_id = localStorage.getItem(server.COMPANYID);

    // this.userId = localStorage.getItem(server.USER_ID);
    // if (this.userId && api.isLoggedIn()) {
    //   // this.$router.push("/");
    // } else {
    //   this.$store.state.isLogged = false;
    //   this.$router.push("/login");
    // }

    await this.loaddataLeaveRequest(this.userId);
    await this.loadleaveHistory(this.userId);
    this.$hideLoader();
  },
  methods: {
    async getBackList() {
      this.$router.push(`/approver-time-off`);
    },
    openApporverHistory() {
      this.$router.push("/approver-history");
    },
    async loadleaveHistory() {
      const res_leave_history = await api.getListApproveAllHistory(
        localStorage.getItem(server.USER_ID)
      );

      for (const [index, item] of res_leave_history.data.entries()) {
        if (item.leave_type == "Sick Leave") {
          item.leave_type = "Sick";
        } else if (item.leave_type == "Vacation Leave") {
          item.leave_type = "Vacation";
        }
        var leave_day = 0;
        var leave_hours = 0;

        leave_day = Math.floor(Number(item.hours_amount) / 8);
        leave_hours = Number(item.hours_amount) - leave_day * 8;

        if (leave_day == 0) {
          if (leave_hours == 0) {
            item.description = `${item.data_date}`;
          } else {
            item.description = item.description = `${item.data_date} (${leave_hours} hours)`;
          }
        } else {
          if (leave_hours == 0) {
            item.description = `${item.data_date} (${leave_day} day)`;
          } else {
            item.description = item.description = `${item.data_date} (${leave_day} day ${leave_hours} hours)`;
          }
        }

        if (item.image != "" && item.image != null) {
          item.image_profile = imageUrl + "/" + item.image;
        } else {
          item.image_profile = "";
        }
      }
      this.leavehistory_list = res_leave_history.data;
      this.datashowAll = res_leave_history.data;
    },
    async goToLeaveApproveById(id, user_id) {
      // เปลี่ยน URL หรือทำการนำทางที่ต้องการ
      this.$router.push(`/leave-request-waiting/${id}/approverhistory`); // หากคุณใช้ Vue Router
      // หรือ window.location.href = 'URL ที่ต้องการ'; // หากคุณต้องการเปลี่ยนไปยัง URL อื่น
    },
    async search_data() {
      const searchTerm = this.search.toLowerCase();
      if (this.datefrom && this.dateto) {
        this.datashowAll = this.leavehistory_list.filter((item) => {
          // ตรวจสอบว่าชื่อหรือประเภทการลา (leave_type) มีคำค้นหาหรือไม่
          return (
            (item.name_eng.toLowerCase().includes(searchTerm) ||
              item.name_th.toLowerCase().includes(searchTerm) ||
              item.leave_type.toLowerCase().includes(searchTerm)) &&
            this.datefrom <= item.str_time && this.dateto >= item.end_time
          );
        });
      } else {
        this.datashowAll = this.leavehistory_list.filter((item) => {
          // ตรวจสอบว่าชื่อหรือประเภทการลา (leave_type) มีคำค้นหาหรือไม่
          return (
            item.name_eng.toLowerCase().includes(searchTerm) ||
            item.name_th.toLowerCase().includes(searchTerm) ||
            item.leave_type.toLowerCase().includes(searchTerm)
          );
        });
      }
    },
    previousPage() {
      if (this.page > 1) {
        this.page -= 1;
      }
    },
    nextPage() {
      if (this.page < this.pageCount) {
        this.page += 1;
      }
    },

    async loaddataLeaveRequest(id) {
      // const result = await api.getListApproveByApproverIDbyCompany(id,localStorage.getItem(server.COMPANYID));
      const result = await api.getListApproveIdNow(id);
      this.mDataArray = result.data;

      // console.log("dateAll:")
      //   console.log(this.dataAll)
      //   console.log("loadLeave", JSON.stringify(this.dataAll));

      // image

      this.mDataArray.forEach((item) => {
        var tmp = {
          id: 13,
          employee_id: "163",
          startDate: "2022-06-20T01:30:00.000Z",
          endDate: "2022-06-20T10:30:00.000Z",
          startDate2: "2022-06-20 08:30:00",
          endDate2: "2022-06-20 17:30:00",
          amount: "8.00",
          leaveTypeId: 2,
          leave_type: "ลากิจ",
          description: "test emp",
          description_approve: "test approve emp",
          approve_id: 1,
          approve_name: "Request",
          approver_level1: 80,
          fullName: "นาย Test Employee",
          image: "",
        };
        tmp.id = item.id;
        tmp.employee_id = item.employee_id;
        tmp.startDate = item.startDate;
        tmp.endDate = item.endDate;
        tmp.startDate2 = item.startDate2;
        tmp.endDate2 = item.endDate2;
        tmp.startDateS = item.startDateS;
        tmp.endDateS = item.endDateS;
        tmp.amount = item.amount;
        tmp.amount_show = this.quotaListConvert(item.amount / 8);
        tmp.leaveTypeId = item.leave_type_id;
        tmp.leave_type = item.leave_type;
        tmp.description = item.description;
        tmp.description_approve = item.description_approve;
        tmp.approve_id = item.approve_id;
        tmp.approve_name = item.approve_name;
        tmp.approver_level1 = item.approver_level1;
        tmp.fullName = item.fullName;
        // tmp.image = item.image;

        if (item.image == "" || item.image == null) {
          tmp.image = imageUrl + "/personal.png";
        } else {
          tmp.image = imageUrl + "/" + item.image;
        }

        this.dataAll.push(tmp);
      });

      console.log(this.dataAll);

      // this.dataAll = result.data;
      // this.mDataArray = result.data;

      // this.$showLoader();
    },
    quotaListConvert: function(H) {
      var d = 0;
      var h = 0;
      var m = 0;
      var tmp1 = parseFloat(H * 480);
      var tmp_final;

      var tmp_d = tmp1 / 480;

      d = Math.floor(tmp_d);
      h = Math.floor((tmp_d - d) * 8);
      m = Math.floor(((tmp_d - d) * 8 - h) * 60);

      tmp_final = `${d} Days ${h} Hour ${m} Minute`;

      return tmp_final;
    },
  },
};
</script>

<style scoped>
.bg-colorth {
  background-color: #595959;
  color: red;
}
.text-left {
  color: aliceblue;
}
.widthsizesearch {
  width: 70%;
}
.theme--light.v-card {
  border-color: white;
}

.hover-bg {
  transition: background-color 0.3s ease;
  cursor: pointer;
}

.hover-bg:hover {
  background-color: #daf2fa; /* สีที่ต้องการเมื่อ hover */
}
.pagination-info {
  margin-right: 20px; /* เพิ่มพื้นที่ระหว่าง pagination ข้อมูล */
  font-size: 14px; /* ขนาดฟอนต์ */
  color: #0a7ea5; /* เปลี่ยนสีข้อความ */
}

/* ซ่อน pagination */
.hidden-pagination {
  display: none;
}
</style>
